<template>
  <div class="container">
    <!-- 로그탭 내 버튼그룹 -->
    <div class="tabs-layout-wrap">
      <lego-segment-wrapper v-model="dropHolderValue" style="margin-right: 10px">
        <lego-segment-button value="1" @click="showGridRow">
          <sc-icon
            name="ri-list-view-new"
            :style="isThumbnail ? 'color: #868D9C' : 'color: #2C59D9'"
            :size="16"
            v-lego-tooltip="$t('button.detail')"
          />
        </lego-segment-button>
        <lego-segment-button value="2" @click="showThumbnail">
          <sc-icon
            name="ri-grid_view_new"
            :style="!isThumbnail ? 'color: #868D9C' : 'color: #2C59D9'"
            :size="16"
            v-lego-tooltip="$t('button.summary')"
          />
        </lego-segment-button>
      </lego-segment-wrapper>
      <lego-button border primary @click="openLogDetailModal"
        >{{ t('button.logSearch') }}
      </lego-button>
    </div>

    <!-- 로그탭 내 차트 레이아웃 -->
    <div
      :style="items.length ? 'height:320px !important' : 'height: 100% !important'"
      class="container__content"
    >
      <c-scroll
        v-if="isShowLogData"
        :classStyle="'cus-c-scroll-height-width'"
        style="width: 100%; height: 320px; border-radius: 4px; padding-right: 12px"
        :style="{ height: scrollHeight }"
      >
        <lego-dashboard
          :col="layoutOption.col"
          :row="layoutOption.row"
          :gap="layoutOption.gap"
          :vsize="isThumbnail ? 194 : 224"
          :key="isThumbnail"
        >
          <lego-dashboard-item
            v-for="(item, idx) in dashboardItems"
            v-slot:default="{ position }"
            :x="item.x"
            :y="item.y"
            :w="1.0"
            :h="item.h"
            :key="idx"
            :widthContent="1234"
            :class="{ active: getBorderDashboardItem(item) }"
          >
            <DetailChart
              :is-log="true"
              :is-thumbnail="isThumbnail"
              :item="item"
              :idx="idx"
              mode="log"
              :position="position"
            />
          </lego-dashboard-item>
        </lego-dashboard>
      </c-scroll>

      <!-- 로그수집 Agent -->
      <div class="container__content-log" v-else>
        <div v-if="isNotSupportLog === false" class="empty-wrap">
          <div v-if="!isK8sLogDataActive">
            <SetLogEvent :value="'Kubernetes'" />
          </div>
          <div v-else-if="!isCFsLogDataActive">
            <SetLogEvent :value="'CloudFunctions'" />
          </div>
          <div v-else>
            <SetLogEvent :value="'NotSupport'" />
          </div>
        </div>
        <div v-if="productTypeCode === 'Kubernetes' && logDataKey.length <= 0" class="empty-wrap">
          <SetLogEvent :value="'Kubernetes'" />
        </div>
        <div
          v-else-if="productTypeCode === 'Cloud Functions' && logDataKey.length <= 0"
          class="empty-wrap"
        >
          <SetLogEvent :value="'CloudFunctions'" />
        </div>
        <div v-else-if="isNotSupportLog && !isShowLogData" class="empty-wrap">
          <SetLogEvent :value="'Agent'" />
        </div>
      </div>
    </div>
    <div class="scpm_table">
      <lego-paging-table
        v-if="headers.length && items.length"
        ref="refLegoPagingTable"
        v-model="selected"
        multiSelect
        isNotScrollX
        :scrollMaxRow="page.totalPages > 1 ? 5 : 7"
        selectAll
        tableFixed
        :items="items"
        :headers="headers"
        :pagination="page"
        :selectActionControl="false"
        :noDataText="noDataText"
        fixColumnBorder="none"
        @change="changeRowPerPage"
        @pageMove="changeCurrentPage"
        @sort="onClickSortTable"
        valueKey="service.type"
      />
    </div>

    <LogSearchPopup
      v-if="isLogCollectionAgent"
      disableProductType
      :params="modalLogParam"
      @close="popupClose()"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import i18nMixin from '@/mixins/i18n.mixin.js';
import monTargetMixin from './monTarget.mixin.js';
import tableMixins from '@/mixins/table.mixin.js';
import SetLogEvent from '@/containers/popup/components/SetLogEvent.vue';
import LogSearchPopup from '@/containers/logs/logCollections/LogSearchPopup.vue';
import DetailChart from './DetailChart.vue';
import { useColumnSetting } from '@/composables/useColumnSettings.js';
import { TableKeys } from '@/config/tableColumns';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';
import { useChart } from '@/composables/useChart.js';
import TooltipAndOther from '@/containers/components/TooltipAndOther';

const { formatDateTime, FULL_TIME_FORMAT } = useDateTimeFormat();
const { handleDataChart } = useChart();

export default {
  name: 'MonTargetLog',
  emits: ['close', 'toggle-sub-modal'],
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    scrollHeight: {
      type: String,
      default: ''
    },
    searchDate: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [i18nMixin, monTargetMixin, tableMixins],
  components: {
    DetailChart,
    LogSearchPopup,
    SetLogEvent
  },

  computed: {
    // 검색 기간 날짜 차이(day)
    searchDatePeriod() {
      return this.searchDate
        ? moment(this.searchDate.queryEndDt).diff(moment(this.searchDate.queryStartDt), 'days')
        : 0;
    },

    isK8sCFs() {
      return this.productTypeCode === 'Kubernetes' || this.productTypeCode === 'Cloud Functions';
    }
  },

  watch: {
    searchDate: {
      deep: true,
      handler(value, oldValue) {
        this.onSearchDataChange(value, oldValue);
      }
    },
    selected() {
      legoEventBus.$emit('click-outside-datePicker');
    }
  },

  data() {
    return {
      modalParam: {},
      startDate: '',
      endDate: '',
      dropHolderValue: '2', // 레이아웃 버튼그룹 초깃값
      isThumbnail: true,
      isShowLogData: true,
      isNotSupportLog: true,
      isK8sLogDataActive: true,
      isCFsLogDataActive: true,
      productId: '',
      productResourceId: '',
      productTypeCode: '',
      isLogCollectionAgent: false,
      logUsagesData: [],
      dashboardItems: [],
      layoutOption: {
        // 대시보드 레이아웃 옵션
        col: 4,
        row: 1,
        gap: 12,
        vsize: 194
      },
      logsList: [],
      logDataKey: [],
      logIdx: 0,
      logCnt: 0,
      apiParams: {
        productResourceId: this.params.productResourceId,
        queryStartDt: this.getSearchDate().queryStartDt,
        queryEndDt: this.getSearchDate().queryEndDt,
        interval: this.getSearchDate().chartTimeUnit,
        logName: ''
      },
      isLogStateActive: true,
      isProductAuth: true,
      headers: [],
      selected: [],
      page: {
        rowsPerPage: 20,
        currentPage: 1,
        totalItems: 0,
        currentIndex: 0
      },
      items: [],
      sort: {
        sortDataField: '',
        sortOrder: ''
      },
      tableHeaderTranslateKey: 'label',
      tableHeaderCustomize: {
        logName: {
          text: 'fileName'
        },
        logPath: {
          text: 'filePath'
        }
      }
    };
  },

  async created() {
    const logSetupCustomKey = this.initlogSetupCustom();

    const { activeColumns, activeColumnsWithCustom, setCustomizeData, setCustomCell } =
      useColumnSetting(TableKeys.LogSetup, '', logSetupCustomKey);
    setCustomCell(this.initCustomCellHeader());
    setCustomizeData(this.tableHeaderCustomize, this.tableHeaderTranslateKey);
    activeColumnsWithCustom();
    this.headers = activeColumns;

    this.modalParam = this.params;
    this.isThumbnail = this.params.type;
    this.productId = this.params.productId;
    this.productResourceId = this.params.productResourceId;
    this.productTypeCode = this.params.productTypeCode;
    this.startDate = this.params.startDate;
    this.endDate = this.params.endDate;

    // 탭 권한 체크
    await this.checkAuthorization(this.productResourceId, this.productTypeCode);
  },

  mounted() {},

  methods: {
    onClickSortTable(item) {
      legoEventBus.$emit('click-outside-datePicker');
      this.onClickSort(item);
    },
    initCustomCellHeader() {
      return {
        'log.file.path': {
          customCell: {
            name: 'logFilePath',
            components: { TooltipAndOther },
            props: {
              value: {
                type: String,
                default: ''
              }
            },
            computed: {
              items() {
                return this.value?.split(',');
              }
            },
            template: `
              <TooltipAndOther  v-if='value' onlyShowAnd :items='items'/>`
          }
        },
        logMetrics: {
          customCell: {
            name: 'logMetrics',
            components: { TooltipAndOther },
            props: {
              value: {
                type: String,
                default: ''
              }
            },
            computed: {
              items() {
                return this.value?.split(',');
              }
            },
            template: `
              <TooltipAndOther onlyShowAnd :items='items'/>`
          }
        }
      };
    },
    handleTooltip(value) {
      let lstValue = value.split(',');
      let content = '';

      for (let i = 0; i < lstValue.length; i++) {
        if (i == 8) {
          content += ',...';
          break;
        }

        content += i > 0 ? ' \\n' + lstValue[i].trim() : lstValue[i].trim();
      }
      return content;
    },
    initlogSetupCustom() {
      return {
        logName: {
          text: this.$util.capitalize(this.$t('label.collection')) + ' ' + this.$t('label.log') // 수집로그
        },
        logPath: {
          text: this.$util.capitalize(this.$t('label.file')) + ' path' // 파일 경로
        }
      };
    },

    // 탭 권한 체크
    async checkAuthorization(productResourceId, productTypeCode) {
      let params = {
        productResourceIds: [productResourceId],
        actionName: 'MonitorView'
      };
      await this.$http.product
        .checkProductAuthorization(params, productTypeCode, true)
        .then(async () => {
          this.isProductAuth = true;
          await this.getProductTypeAble();
          // await this.getLogState();
        })
        .catch((error) => {
          if (error && error.code == 'AccessDenied') {
            this.isProductAuth = false;
            this.$alert(error, async () => {
              this.isProductAuth = false;
              await this.getProductTypeAble();
              // await this.getLogState();
            });
          }
        });
    },

    // refresh 데이터 정보 변경
    onSearchDataChange(value, oldVaue) {
      if (value == oldVaue || value === undefined) {
        return;
      }
      this.getData();
    },

    // 상품 유형 체크
    getProductTypeAble() {
      let productTypeAble = 'N';
      this.$http.product.getProductSubTypes('Y').then((data) => {
        if (this.$util.isNotEmpty(data)) {
          for (let i = 0; i < data.length; i++) {
            if (this.productTypeCode === data[i].productTypeCode) productTypeAble = 'Y';
          }

          if (productTypeAble === 'Y') {
            this.isShowLogData = true;
            this.getData();
          } else {
            this.isShowLogData = false;
            this.isNotSupportLog = false;
          }
                    
          let tempProducTypeCode = [];
          let nowProductTypeCode = this.productTypeCode;
          tempProducTypeCode = data
            .map((item) => item.productTypeCode)
            .filter((p) => p === nowProductTypeCode)
            .shift();

          if (this.isK8sCFs) {
            if (tempProducTypeCode === 'Kubernetes') this.isK8sLogDataActive = false;
            if (tempProducTypeCode === 'Cloud Functions') this.isCFsLogDataActive = false;
          }
        }
      });
    },

    // log data key 조회
    getData() {
      let params = {
        monKey: this.params.monKey,
        sort: ['@timestamp:desc'],
        size: this.page.rowsPerPage,
        page: this.page.currentPage - 1
      };
      if (this.sort.sortDataField) {
        params.sort = [this.sort.sortDataField + ':' + this.sort.sortOrder];
      }
      const productTypeCode = this.params.productTypeCode;
      this.apiGetLogs(params, productTypeCode, true)
        .then((data) => {
          if (data.contents.length === 0 && data.returnCount === 0) {
            this.isLogStateActive = false;
            this.isNotSupportLog = true;
            this.isShowLogData = false;
          } else {
            this.selected = [];
            this.isShowLogData = true;
            this.setTableInfo(data, false);
            this.handleLogsData(data);
          }
        })
        .catch((err) => {
          if (err && err.code === 'AccessDenied') {
            this.$alert(err, () =>
              this.setAccessDeniedMessage(
                `${'message.accessError' + err.params.find((item) => item.name === 'action').value}`
              )
            );
          }
        });
    },

    async handleLogsData(data) {
      if (this.$util.isNotEmpty(data)) {
        this.logsList = data.contents;
        this.logCnt =
          data.totalCount > this.logsList.length ? this.logsList.length : data.totalCount;
        this.logDataKey = [];

        for (let i = 0; i < this.logCnt; i++) {
          const dataItem = data.contents[i];
          if (dataItem) {
            this.logDataKey.push(dataItem['service.type']);
          }
        }
        await this.initChartInfo();
        await this.createChart();
      }
    },

    //  log data 상태
    getLogState() {
      this.$http.log.getLogProductTypes().then((data) => {
        if (this.$util.isNotEmpty(data)) {
          let tempProducTypeCode = [];
          let nowProductTypeCode = this.productTypeCode;
          tempProducTypeCode = data
            .map((item) => item.productTypeCode)
            .filter((p) => p === nowProductTypeCode)
            .shift();

          if (!this.isK8sCFs) {
            return;
          }

          if (this.isK8sCFs) {
            if (tempProducTypeCode === 'Kubernetes') this.isK8sLogDataActive = false;
            if (tempProducTypeCode === 'Cloud Functions') this.isCFsLogDataActive = false;
          }
        }
      });
    },

    // 초기 차트정보 세팅
    initChartInfo() {
      // 로그 목록 없을땐 로그 사용량 조회 하지 않도록 수정
      if (this.logDataKey.length <= 0) {
        this.isShowLogData = false;
        return;
      }

      let logChartInfos = [];
      const buildOption = this.buildOption();
      this.logsList.forEach((g, i) => {
        this.apiParams.logName = g['service.type'];

        let params = this.$util.deepCopy(this.apiParams);

        let chartOption = {
          title: g['service.type'],
          key: g['service.type'],
          chartType: 'line',
          chartOption: _.cloneDeep(buildOption),
          chartList: [],
          w: 1,
          h: 1,
          x: i % 4,
          y: Math.floor(i / 4),
          zoom: false,
          options: params,
          logSq: g['service.type'],
          metric: {
            metricKey: g['service.type'],
            logSq: g['service.type'],
            logPath: g['log.file.path']
          }
        };
        if (!this.isThumbnail) {
          chartOption.x = 0;
          chartOption.y = i;
          chartOption.chartOption.grid.left = 60;
          chartOption.chartOption.grid.right = 80;
        }
        logChartInfos.push(chartOption);
      });
      this.dashboardItems = logChartInfos;
    },

    // 차트 그리기
    async createChart() {
      let startDt = this.getSearchDate().queryStartDt;
      let endDt = this.getSearchDate().queryEndDt;
      let interval = this.getSearchDate().chartTimeUnit;

      await this.dashboardItems.forEach((item) => {
        let params = item.options;
        params.queryStartDt = startDt;
        params.queryEndDt = endDt;
        params.interval = interval;

        this.apiGetLogUsages(params, this.productTypeCode, true)
          .then((data) => {
            item.chartList = [];
            if (!this.isProductAuth || !data.logCounts.length) return;
            const unit = 'cnt';
            const { logCounts } = data;
            let lastValue = 0;
            const maxValue = logCounts.reduce((acc, cur) => Math.max(acc, cur.value), -Infinity);
            const { unit: usageUnit } = this.$util.convertNumberSymbol(maxValue, unit);
            let tooltipChart = { date: '', maxValueChart: [] };
            let logUnit = this.getLogUnit(unit, data.logCounts);

            tooltipChart.date = moment(logCounts[logCounts.length - 1].ts).format(
              'YYYY-MM-DD HH:mm:ss'
            );
            // Function format data before show chart
            const logCountsChart = handleDataChart(logCounts, interval, startDt, endDt);
            const decimal = 2;
            const chartData = logCountsChart.map((el) => {
              if (el.value === null) return [el.ts, el.value];
              const numVal = Number(el.value);
              const { value } = this.$util.toSpecificNumberSymbol(numVal, usageUnit, unit);
              const roundedValue = Number(value.toFixed(decimal));
              return [el.ts, roundedValue];
            });
            const lastIndex = chartData.findLastIndex((chart) => chart[1] !== null);
            if (lastIndex > -1) lastValue = chartData[lastIndex][1];
            item.maxValue = `${lastValue}${usageUnit}`;
            chartData[lastIndex] = {
              value: chartData[lastIndex],
              symbol: 'emptyCircle',
              symbolSize: '7'
            };
            tooltipChart.maxValueChart.push({
              color: this.chartThemeColor[0],
              name: data.logName,
              value: lastValue.toString()
            });
            item.metricUnit = unit;
            item.chartOption.yAxis = {
              name: '(' + logUnit.orgUnit + ')',
              axisLabel: {
                formatter: _.bind((value) => {
                  return this.$filters.comma(value);
                }, this)
              }
            };
            const yAxisLabel = usageUnit ? `{value} ${usageUnit}` : `{value}`;
            item.chartOption.yAxis.axisLabel.formatter = yAxisLabel;
            item.tooltipChart = tooltipChart;
            item.chartList = [{ data: chartData, name: data.logName, dataIndex: lastIndex + 2 }];
          })
          .catch((err) => {
            if (err && err.code == 'AccessDenied') {
              item.chartList = [];
            }
          });
      });
    },

    // 차트 상세보기
    showGridRow() {
      legoEventBus.$emit('click-outside-datePicker');
      this.layoutOption = {
        col: 1,
        row: this.dashboardItems.length,
        gap: 10,
        vsize: 300
      };
      this.dashboardItems.forEach((item, i) => {
        item.x = 0;
        item.y = i;
        item.zoom = false;
        item.chartOption.grid.left = 60;
        item.chartOption.grid.right = 80;
      });
      this.isThumbnail = false;
    },

    // 차트 요약 보기
    showThumbnail() {
      legoEventBus.$emit('click-outside-datePicker');
      this.layoutOption = {
        col: 4,
        row: 1,
        gap: 10,
        vsize: 194
      };
      this.dashboardItems.forEach((item, i) => {
        item.x = i % 4;
        item.y = Math.floor(i / 4);
        item.zoom = false;
        item.chartOption.grid.left = 20;
        item.chartOption.grid.right = 20;
      });
      this.isThumbnail = true;
    },

    openLogDetailModal() {
      let selectedLog = [
        {
          productName: this.params.productName,
          productResourceId: this.productResourceId,
          monKey: this.params.monKey,
          productTypeCode: this.params.productTypeCode
        }
      ];
      if (this.selected.length) {
        selectedLog = this.selected.map((item) => {
          return {
            ...item,
            productName: this.params.productName,
            productResourceId: this.productResourceId,
            monKey: this.params.monKey,
            productTypeCode: this.params.productTypeCode
          };
        });
      }
      this.$http.product
        .checkProductAuthorization(
          {
            productResourceId: this.productResourceId,
            actionName: 'MonitorView'
          },
          this.productTypeCode,
          true
        )
        .then(() => {
          this.modalLogParam = {
            productTypeCode: this.productTypeCode,
            productTypeName: this.params.productTypeName,
            productId: this.selected.length ? '' : this.productId,
            productName: this.params.productName,
            selectedLog: selectedLog,
            mode: 'logSearch',
            modeDetail: !!this.selected.length
          };
          this.isLogCollectionAgent = true;
          this.$emit('toggle-sub-modal', true);
        })
        .catch((err) => {
          if (err && err.code == 'AccessDenied') {
            this.$alert(err);
          }
        });
    },

    // 차트 옵션 생성
    buildOption() {
      return {
        grid: {
          left: 20,
          top: 34,
          right: 20,
          bottom: 0,
          containLabel: true
        },
        legend: {
          bottom: 16,
          show: false
        },
        xAxis: [
          {
            type: 'time',
            splitNumber: 5,
            nameGap: -11,
            axisLabel: {
              // interval: 'auto',
              fontSize: 11,
              hideOverlap: true,
              formatter: this.xLabelFormatter
            }
          }
        ],
        yAxis: {
          name: '',
          axisLabel: {
            formatter: '{value}'
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          textStyle: {
            color: '#000'
          },
          axisPointer: {
            type: 'line',
            label: {
              formatter: (params) => {
                let label = params.value;
                if (params.axisDimension == 'x') {
                  label = formatDateTime(label, FULL_TIME_FORMAT);
                } else if (params.axisDimension == 'y') {
                  label = this.$filters.comma(Math.ceil(label));
                }
                return label;
              }
            }
          },
          confine: true,
          renderMode: 'html',
          // extraCssText: 'max-height:' + (this.isThumbnail ? '230px' : '290px') + '; overflow:auto;',
          triggerOn: 'mousemove',
          enterable: false,
          transitionDuration: 0.8,
          appendToBody: true,
          position: (point, params, dom, rect, size) => {
            return this.$util.getPositionTooltip(point, size);
          }
        }
      };
    },

    getLogUnit(logUnit, data) {
      let logValues = [];
      data.forEach((item) => logValues.push(Math.max(Number(item.value))));
      let maxValue = Math.max(...logValues);

      let tmp = this.$util.formatNumber(maxValue, logUnit, 2);
      let unit = tmp.unit === '' ? logUnit : tmp.unit;

      return {
        orgUnit: logUnit,
        unit: unit
      };
    },

    close() {
      this.$emit('close', true);
    },

    popupClose() {
      this.isLogCollectionAgent = false;
      this.$emit('toggle-sub-modal', false);
    },

    // 조회시간 설정
    getSearchDate() {
      if (this.searchDate) {
        return {
          queryStartDt: this.searchDate.queryStartDt,
          queryEndDt: this.searchDate.queryEndDt,
          chartTimeUnit: this.searchDate.chartTimeUnit
        };
      } else {
        return {
          queryStartDt: moment(new Date()).add(-6, 'hours').toISOString(), // 6시간 전
          queryEndDt: moment(new Date()).toISOString(),
          // chartTimeUnit: '1h'
          chartTimeUnit: '5m'
        };
      }
    },

    xLabelFormatter(value) {
      let type = this.getSearchDate().chartTimeUnit;
      if (type === '5m') {
        return moment(Number(value)).format('HH:mm');
      } else {
        const dateTime = moment(Number(value));
        return `${dateTime.format('MM-DD')}\n${dateTime.format('HH')}h`;
      }
    },
    getBorderDashboardItem(item) {
      return this.selected.find((item1) => item1['service.type'] === item.logSq);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;

  &__content {
    height: 100%;
    border-bottom: 1px #dbdce1 solid;

    &-log {
      height: 100%;
    }
  }
}

:deep .detail-chart {
  height: 252px;
}

.c-chart-wrap {
  height: 170px;
  overflow: hidden;
}

.chart-bottom-legend {
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
}

.legend-item {
  display: inline-block;
  padding-right: 18px;

  .cus-circle {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin: 5px 4px 3px 0;
    vertical-align: middle;
    background-color: #20bac2;
    border-radius: 50%;
  }
}

.empty-wrap {
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}

.tabs-layout-wrap {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  text-align: right;
}

.cus-c-scroll-height-width :deep .simplebar-content {
  width: calc(100% - 20px);
}

:deep .lego-dashboard-item {
  display: flex;
  flex-direction: column;

  .no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    color: rgba(51, 51, 51, 0.4);
    font-weight: 500;
    font-size: 14px;
    gap: 12px;
  }
}

:deep .active {
  .chart-thumnail-item {
    border: 1px solid #2c59d9 !important;
  }
}

:deep .lego-segment-wrapper {
  .lego-segment-button.lego-segment-button--medium {
    min-width: auto;
    width: 32px;
    height: 32px;
  }
}

.chart-thumnail-item {
  // height:270px;
  padding: 0;
  border: 1px solid #e3e3e3;
}

.chart-thumnail-title {
  padding: 10px;
}

.chart-detail {
  width: 100%;
  // height: 230px !important;
}

.chart-detail-item {
  padding: 8px 16px 16px 16px;
  border: 1px solid #e3e3e3;

  .chart-thumnail-content {
    display: flex;
    align-items: flex-end;
    height: 100%;
  }
}

.chart-detail-content {
  height: 100%;
}

.chart-detail-title {
  padding-bottom: 8px;
}

:deep .lego-tooltip {
  max-width: 500px !important;
}

:deep .scpm_table {
  margin-top: 8px;
}
</style>
